import { useState } from "react";
import sortBy from "lodash/sortBy";

import PublicLayout from "../layouts/PublicLayout";
import ListProvidersScreen from "../../components/providers/ListProvidersScreen";
import { useGetProvidersQuery } from "../../redux/services/providerApi";

const handleFilterChange = ({setFilter, pageIndex, pageSize}) => (e, filter) => {
  setFilter({
    ...filter, 
    is_hidden: false, 
    skip: pageIndex * pageSize,
    limit: pageSize,
    sort: 'user__last_name',
  });
};

const ListProvidersPage = props => {
  const [pageSize, setPageSize] = useState(100);
  const [pageIndex, setPageIndex] = useState(0);
  const [filter, setFilter] = useState({
    is_hidden: false, 
    skip: pageIndex * pageSize, 
    limit: pageSize,
    sort: 'user__last_name',
  });
  const providersQuery = useGetProvidersQuery(filter);
  const childProps = {
    providers: sortBy(providersQuery?.data || [], 'user.last_name'),
    loading: providersQuery.isLoading,
    filter,
    onFilterChange: handleFilterChange({setFilter}),
    backgroundColor: 'rgb(245, 251, 255)',
  };
  return (
    <PublicLayout {...childProps}>
      <ListProvidersScreen {...childProps} />
    </PublicLayout>
  );
};

export default ListProvidersPage;